export default __webpack_public_path__ + "static/media/trlogo.6b12bc94.png";